import React from "react"
import classnames from "@utils/classnames"
import Section from "@components/section"
import Title from "@components/title"
import styles from "./specialGuests.module.scss"

const GUESTS = [
  {
    name: "图特哈蒙",
  },
  {
    name: "郝祥海",
  },
  {
    name: "范克里夫大尉",
  },
  {
    name: "雷电",
  },
  {
    name: "李厚辰",
  },
  {
    name: "猫牧师",
  },
  {
    name: "女王盐",
  },
  {
    name: "喂狗组 羽毛",
  },
  {
    name: "元何元",
  },
  {
    name: "贪玩歌姬小宁子",
  },
  {
    name: "Quin",
  },
  {
    name: "这样重这样轻",
  },
  {
    name: "STN 屎蛋",
  },
  {
    name: "STN 小索",
  },
  {
    name: "TNA速通会",
  },
  {
    name: "北极熊剩饭",
  },
  {
    name: "悖论",
  },
  {
    name: "伯爵",
  },
  {
    name: "大蓝",
  },
  {
    name: "惠龙",
  },
  {
    name: "解说老陈",
  },
  {
    name: "静电场朔",
  },
  {
    name: "老张",
  },
  {
    name: "楼座",
  },
  {
    name: "佩奇",
  },
  {
    name: "弱智骚年",
  },
  {
    name: "文轩",
  },
  {
    name: "闻闻",
  },
  {
    name: "小包",
  },
  {
    name: "叶秋",
  },
  {
    name: "一团团",
  },
]

const SpecialGuests = React.memo(props => {
  return (
    <Section id="block-guests">
      <Title en="SPECIAL GUESTS">邀请嘉宾</Title>
      <div className={styles.guests}>
        {GUESTS.map(({ thumb, name, desc }, i) => {
          return (
            <div className={styles.guest} key={name}>
              <img
                src={`https://site.gcores.com/assets/fusion2021/avatars/avatar${i +
                  1}.png`}
                alt={name}
              />
              <div>
                <h3>{name}</h3>
              </div>
            </div>
          )
        })}
      </div>
    </Section>
  )
})

SpecialGuests.displayName = "SpecialGuests"
export default SpecialGuests
